import { waitingRoomApi } from '../api/waiting-room'

export const {
  useGetWaitingRoomQuery,
  useGetManageableWaitingRoomsQuery,
  useListWaitingRoomsQuery,
  useLazyListWaitingRoomsQuery,
  useCreateWaitingRoomMutation,
  useUpdateWaitingRoomMutation,
  useDeleteWaitingRoomMutation,
  useGetWaitingRoomDoctorsQuery,
  useGetWaitingRoomDoctorsStatusQuery,
  useGetMyWaitingRoomFairStatusQuery,
  useGetWaitingRoomActiveConsultationsQuery,
  useGetWaitingRoomConsultationPreviewQuery,
  useAcceptWaitingRoomConsultationMutation,
  useJoinWaitingRoomConsultationMutation,
  usePassWaitingRoomOfferMutation,
  useJoinWaitingRoomMutation,
  useLeaveWaitingRoomMutation,
} = waitingRoomApi
